import { Component, OnInit } from '@angular/core';
import { DeudaList } from "../deuda/models/deuda";
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { pagoNotificacionService } from "./pagonotificacion.service";
import { Persona } from "../deuda/models/persona";
import { pagos360 } from "../pagos/models/pagos360";
import { Pagos360Service } from "../pagos/pagos360/pagos360.service";
import { environment } from "src/environments/environment";
import { comprobante } from "../deuda/models/comprobante";

@Component({
  selector: 'app-pagonotificacion',
  templateUrl: './pagonotificacion.component.html',
  providers: [pagoNotificacionService],
  styleUrls: ['./pagonotificacion.component.scss']
})
export class PagonotificacionComponent implements OnInit {

  tributopersona: Persona;
  items: DeudaList[] = [];
  monto: number;
  nrocuenta: string;
  idjurisdiccion: number;
  tipotributo: string;
  cantidad;
  codigo = "";
  conceptoTributo = '';//variable que uso para traer el concepto abreviado del tipo tributo
  cuotasFiltradas = [];
  nombre;
  apellido;
  email;
  anoCuota;
  mesCuota;
  Pagos360: pagos360;
  comprobante: comprobante;

  constructor(
    private service: pagoNotificacionService,
    private service360: Pagos360Service
  ) {
  }

  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,

  ]);

  ngOnInit() {
    const urlParams = new URLSearchParams(window.location.search);
    this.nrocuenta = urlParams.get('nroCuenta');
    this.idjurisdiccion = parseInt(urlParams.get('idjurisdiccion'));
    this.tipotributo = urlParams.get('idtipotributo');
    this.nombre = urlParams.get('nombre');
    this.apellido = urlParams.get('apellido');
    this.mesCuota = urlParams.get('mesCuota');
    this.anoCuota = urlParams.get('anoCuota');
    this.emailFormControl.setValue(urlParams.get('email'));

    let mesCuota = urlParams.get('mesCuota');
    let anoCuota = urlParams.get('anoCuota');

    this.service.getDeudaList(this.nrocuenta,1 ,this.idjurisdiccion, this.tipotributo).subscribe((response) => {
      this.cuotasFiltradas = response.filter(function (currentElement) {
        return parseInt(currentElement.nro_cuota) == parseInt(mesCuota) && parseInt(currentElement.ano_cuota) == parseInt(anoCuota);
      });
      var aux = 0;
      this.cuotasFiltradas.forEach(function (value) {
        aux = + value.deuda_actualizada;
      });
      this.monto = aux;
    });
  }


  Pagar(): void {
    let concepto = "";

    if (this.tipotributo == "AUAU") {
      concepto = "AUTOMOTORES";
    } else if (this.tipotributo == "ININ") {
      concepto = "TASA POR SERVICIO A LA PROPIEDAD";
    } else if (this.tipotributo == "FIFI") {
      concepto = "PLAN DE PAGO";
    } else if (this.tipotributo == "OBSA") {
      concepto = "SERVICIO DE AGUA Y CLOACAS";
    } else if (this.tipotributo == "CECE") {
      concepto = "CEMENTERIO";
    } else if (this.tipotributo == "CICI") {
      concepto = "COMERCIO E INDUSTRIA";
    }
    else if (this.tipotributo == "TAV") {
      concepto = "TASAS VARIAS";
    }

    var fecha = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000); //???
    var datosconcepto = [];

    for (var i = 0; i < this.cuotasFiltradas.length; i++) {
      datosconcepto.push(
        "Cuota: " +
        this.cuotasFiltradas[i].nro_cuota +
        " Año: " +
        this.cuotasFiltradas[i].ano_cuota +
        " Importe: " +
        this.cuotasFiltradas[i].deuda_actualizada
      );
    }
    var datos = {

      description: concepto + " " + this.mesCuota + " " + datosconcepto,
      external_reference: "TRASUS",
      first_due_date:
        fecha.getDate() +
        "-" +
        (fecha.getMonth() + 1) +
        "-" +
        fecha.getFullYear(),
      first_total: this.monto,
      second_due_date:
        fecha.getDate() +
        "-" +
        (fecha.getMonth() + 1) +
        "-" +
        fecha.getFullYear(),
      second_total: this.monto,
      payer_name: this.nombre + " " + this.apellido,
      payer_email: this.emailFormControl.value,//this.email,
      back_url_success:
        //"https://www.sigemyt.com/emisiondeudavscl/inicio",
        "https://www.sigemyt.com/portalmunicipal/inicio",
      back_url_pending:
        //"https://www.sigemyt.com/emisiondeudavscl/inicio",
        "https://www.sigemyt.com/portalmunicipal/inicio",
      metadata: {
        cuotas: [],
        id_tributo: "",
        id_obligación: "",
        nro_cuenta: "",
        nro_cuota: "",
        anio_cuota: "",
        concepto: concepto,
        tipo_tributo: this.tipotributo,
        dias: 1,
      },
      excluded_channels: [],
    };

    for (var i = 0; i < this.cuotasFiltradas.length; i++) {
      datos.metadata.cuotas.push({
        first_due_date:
          fecha.getDay() +
          1 +
          "-" +
          (fecha.getMonth() + 1) +
          "-" +
          fecha.getFullYear(),
        first_total: this.cuotasFiltradas[i].capital_facturado,
        second_due_date:
          fecha.getDay() +
          1 +
          "-" +
          (fecha.getMonth() + 1) +
          "-" +
          fecha.getFullYear(),
        second_total: this.cuotasFiltradas[i].deuda_actualizada,
        id_tributo: this.cuotasFiltradas[i].id_tributo_contribuyente,
        id_obligación: this.cuotasFiltradas[i].id_obligacion,
        nro_cuenta: this.nrocuenta,
        first_interest: this.cuotasFiltradas[i].intereses,
        second_interest: 0,
        nro_cuota: this.cuotasFiltradas[i].nro_cuota,
        anio_cuota: this.cuotasFiltradas[i].ano_cuota,
      });
    }
    const p = Object.assign({}, this.Pagos360, datos);



    if (this.emailFormControl.value != '') {

      this.service360.pagos360(p).subscribe((response) => {
        window.open(response["checkout_url"]);
      });
      // setTimeout(() => {                           //<<<---using ()=> syntax
      //   // window.location.href = 'https://www.sigemyt.com/emisiondeudavscl/impuestos';
      //   window.location.href = 'https://www.sigemyt.com/portalmunicipal/inicio';
      // }, 3000);

    }
    else if (this.emailFormControl.value == '') {
      console.log('ingrese un mail');
    }

  }

  cedulon(selected: string): void {
    var seleccionados = this.cuotasFiltradas;
    var datos = {
      tipo_comprobante: 2,
      id_tributo_contribuyente: seleccionados[0].id_tributo_contribuyente,
      cantidad_dias: null,
      items: [],
    };

    for (var i = 0; i < seleccionados.length; i++) {
      var fecha;
      if (this.tipotributo != 'FIFI') {
        fecha = seleccionados[i].fecha_primer_vencimiento;
      }
      else {
        fecha = seleccionados[i].fecha_vencimiento_cuota;
      }
      var item = {
        id_obligacion: seleccionados[i].id_obligacion,
        fecha_vto: fecha,


      };

      datos.items.push(item);
    }
    const p = Object.assign({}, this.comprobante, datos);
    console.log(datos)
    this.service.addComprobante(p)
      .subscribe(response => {
        if (this.tipotributo == 'AUAU') {
          var url = `${environment.urlReporte}reporteCedulonAU?reporteId=2&parametros=${response}`
        }
        else if (this.tipotributo == 'ININ')
          var url = `${environment.urlReporte}reporteCedulonAU?reporteId=3&parametros=${response}`
        else if (this.tipotributo == 'OBSA')
          var url = `${environment.urlReporte}reporteCedulonAU?reporteId=6&parametros=${response}`
        else if (this.tipotributo == 'FIFI')
          var url = `${environment.urlReporte}reporteCedulonAU?reporteId=8&parametros=${response}`
        else if (this.tipotributo == 'CICI')
          var url = `${environment.urlReporte}reporteCedulonAU?reporteId=4&parametros=${response}`
        else if (this.tipotributo == this.conceptoTributo)
          var url = `${environment.urlReporte}reporteCedulonAU?reporteId=41&parametros=${response}`
        this.cuotasFiltradas = [];
        window.open(url);
      });

  }
}
